export class Rapport {
    id: number;
    blob: any;
}
